<template>
  <div style="z-index: 999001">
    <v-date-picker
      :value="value"
      @input="$emit('input', $event)"
      mode="dateTime"
      is24hr
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="relative">
          <vs-input
            :value="inputValue"
            v-on="inputEvents"
            class="w-full"
            :placeholder="placeholder"
            :disabled="disabled"
          />
          <div
            class="absolute top-0 bottom-0 right-0 pr-1 flex items-center"
            v-if="!disabled"
          >
            <feather-icon
              v-if="value"
              icon="XIcon"
              class="cursor-pointer"
              svgClasses="h-5 w-5"
              @click="$emit('input', null)"
            />
          </div>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input"],
};
</script>